module.exports = __webpack_public_path__ + "static/media/busd.a578efd2.png";